// extracted by mini-css-extract-plugin
module.exports = {"container":"IntroText_container___5PBN","copy":"IntroText_copy__f7J1a","line":"IntroText_line__7zDZb","char":"IntroText_char__y00P_"};